import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FilePreviewComponent } from '../file-preview/file-preview.component';

export interface Attachment {
  id?: string;
  name: string;
  title?: string;
  description?: string;
  type?: string;
  url?: string;
  base64?: string;
  size?: number;
}

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.scss']
})
export class AttachmentsListComponent {
  @Input() attachments: Attachment[] = [];
  @Input() loading = false;
  @Input() title = 'Attachments';
  @Input() showPreview = true;
  @Input() showDownload = true;
  @Input() useCustomPreview = false;
  
  @Output() previewClicked = new EventEmitter<Attachment>();
  @Output() downloadClicked = new EventEmitter<Attachment>();
  
  @ViewChild('attachmentPreview') attachmentPreview!: FilePreviewComponent;

  previewAttachment(file: Attachment) {
    if (this.showPreview) {
      this.previewClicked.emit(file);
      
      if (!this.useCustomPreview && this.attachmentPreview) {
        this.attachmentPreview.open({
          url: file.url || '',
          name: file.name || 'File',
          title: file.title,
          description: file.description,
          type: file.type,
          size: file.size,
          base64: file.base64
        });
      }
    }
  }

  downloadAttachment(file: Attachment) {
    this.downloadClicked.emit(file);
    if (file.url) {
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name || 'download';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  hasAttachments(): boolean {
    return this.attachments && this.attachments.length > 0;
  }
}

